import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Tag } from "lucide-react";
import { useI18n } from "../../../i18n";
import { fmtDate } from "../../../lib/format";
import { useLastBought, usePromotions, useShop } from "../hooks";
import { mediaUrl } from "../promoTrack";
import { ProductCard, ProductGridSkeleton } from "../ProductCard";
import { EmptyState } from "../../../components/common/EmptyState";

export default function Promotion() {
  const { id } = useParams();
  const nav = useNavigate();
  const { t, lang } = useI18n();
  const promos = usePromotions();
  const shop = useShop();
  const last = useLastBought();
  const p = (promos.data || []).find((x) => x.id === id);

  if (promos.isLoading || shop.isLoading) return <ProductGridSkeleton />;
  if (!p) return <EmptyState icon={Tag} title={t("promo.notFound")} testId="promotion-not-found" action={<Link to="/app" className="text-sm font-semibold text-brand">{t("shop.nav.home")}</Link>} />;
  const pick = (f) => p[`${f}_${lang}`] || p[`${f}_el`];
  const items = p.item_codes.map((c) => shop.byCode[c]).filter((i) => i && shop.priceMap[i.code]);

  return (
    <div className="space-y-5" data-testid="promotion-page">
      <button type="button" onClick={() => nav(-1)} data-testid="promotion-back" className="flex h-11 items-center gap-1 text-sm font-medium text-slate-600 hover:text-navy"><ArrowLeft className="h-4 w-4" /> {t("shop.back")}</button>
      <header className="overflow-hidden rounded-3xl bg-navy text-white">
        {p.image_url && <img src={mediaUrl(p.image_url)} alt={pick("title")} className="max-h-72 w-full object-cover" data-testid="promotion-image" />}
        <div className="p-5 sm:p-7">
          <span className="text-xs font-semibold uppercase tracking-wider text-brand">{t("promo.badge")} · {t("promo.until", { date: fmtDate(p.end_date) })}</span>
          <h1 className="mt-1 text-3xl font-bold leading-tight sm:text-4xl" data-testid="promotion-title">{pick("title")}</h1>
          {pick("text") && <p className="mt-2 max-w-2xl text-sm text-white/80 sm:text-base">{pick("text")}</p>}
        </div>
      </header>
      {items.length > 0 && (
        <section>
          <h2 className="mb-3 text-base font-semibold text-navy md:text-lg">{t("promo.products")}</h2>
          <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4" data-testid="promotion-products">
            {items.map((i) => <ProductCard key={i.code} item={i} price={shop.priceMap[i.code]} last={last.data?.[i.code]} promo={p} />)}
          </div>
        </section>
      )}
    </div>
  );
}
